import React, { useState, useEffect, useLayoutEffect } from 'react';
import { flowType } from '@utility/userInfo';
import EventEmitter from '@utility/eventSubscribers';
import Loader from '@components/common/Loader/newLoaderModal';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';
import SplitChecks from '../SplitChecks'
import SplitCheckLandScape from '../SplitChecks/splitCheckLandScape';
import cn from 'classnames';
import {
  setSeat,
  updateWithPaymentStages, removeWithPaymentStages, setPaymentCheck
} from '@reducers/orders';
import { spiltCheckPayment } from '@reducers/payment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import { LABEL, CUSTOM_MESSAGES } from '../../../../veriables';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import { openEmployeeCheck, setScreenSaverStatus } from '@reducers/oauth';
import SwipeComponent from '@containers/PaymentTerminalStagePayment/SwipeComponent';


const StagePayment = (props) => {
  const {
    seat,
    deviceInfo,
    setCheckAndSeats,
    serverAppTheme,
    disablePayment,
    paymentLandscapeOrientation
  } = props;
  const isServerApp = flowType() === 'serverApp';
  const isTableTop = flowType() === 'tableTop';
  const countryCode = getObjectValue(() => COUNTRY_CODE[props.auth?.country].dialCode, '1');
  const [selectedStage, setSelectedStage] = useState();
  const [selectedStageIndex, setSelectedStageIndex] = useState(0);
  const isCounter = getObjectValue(() => isServerApp && [1].includes(props.deviceInfo?.deviceGroup?.startMode), false);
  const isDriveThru = getObjectValue(() => isServerApp && [3].includes(props.deviceInfo?.deviceGroup?.startMode), false);
   const isCallCenter = getObjectValue(() => isServerApp && [2].includes(props.deviceInfo?.deviceGroup?.startMode), false);
  const [multiCheckSplitConfirm, setMultiCheckSplitConfirm] = useState(false);

  useLayoutEffect(() => {
    if (window.ReactNativeWebView) {
      if ((isServerApp || isTableTop) && (!isCounter || !isDriveThru || !isCallCenter)) {
        if (!paymentLandscapeOrientation) {
          EventEmitter.changeOrientation({
            orientation: "portrait"
          })
        } else {
          EventEmitter.changeOrientation({
            orientation: "landscape"
          })
        }
      }
    }
  }, [paymentLandscapeOrientation])

  useEffect(() => {
    if (urlSearchParams('screenType') === '28') {
      setCheckAndSeats(selectedStage);
    }
  }, [selectedStage])

  const sortStages = (data) => {
    return data.sort((a, b) => a?.status - b?.status);
  };
  const getSubTotalAmount = (table) => {
    return props.auth.country === 4 ? +(table.subTotalAmount - table.taxAmount) : +(table.subTotalAmount);
  };

  const seatItemHashTable = {};
  seat?.paymentChecks && seat?.paymentChecks?.length > 0 && seat?.paymentChecks?.forEach((paymentChecks, i) => {    
    const splitetails = seat?.splits?.filter((data) => data.id === paymentChecks?.checkSplitId)[0];    
    seatItemHashTable[paymentChecks?.checkSplitId] = {
      paymentStageId: paymentChecks?.checkSplitId,
      items: paymentChecks?.items,
      taxAmount: paymentChecks?.taxAmount,
      subTotalAmount: paymentChecks?.subTotalAmount,
      stage: splitetails,
      status: splitetails?.status,
      totalAmount: paymentChecks?.totalAmount,
      unpaidAmount: paymentChecks?.unpaidAmount,
      paymentComplete: paymentChecks?.paymentComplete,
      paymentAmount: paymentChecks?.paymentAmount,
      splitStatus: splitetails?.splitStatus,
      seats: seat?.seats?.reduce((a, v) => {
        if (splitetails?.seats?.some((d) => d.seatId === v.id)) {
          a.push({ ...v });
        }
        return a;
      }, []),
      itemAmount: paymentChecks?.itemAmount,
      offer: paymentChecks?.offer,
      offers: paymentChecks?.offers,
      loyalty: paymentChecks?.loyalty,
      paidAmount: paymentChecks?.paidAmount,
      giftCardKey: paymentChecks?.giftCard,
      serviceChargeAmount: paymentChecks?.serviceChargeAmount,
      discountAmount: paymentChecks?.discountAmount,
      tip: paymentChecks?.tip,
      tipCollectedAmount: paymentChecks?.tipCollectedAmount || 0,
    };
  });
  const onClickPaymentHandler = (paymentInfo) => {
    const tipInfo = props?.auth?.tipInfo;
    const hasAutoGratuity = seat?.paymentCheck?.hasAutoGratuity;
    const isAutoGratuityPresent = (getObjectValue(() => props.auth?.autoGratuityTipInfo, false) != null);
    if (paymentInfo?.paymentStageId && seatItemHashTable[paymentInfo?.paymentStageId]?.unpaidAmount < 0) {
      props.setErrorPopUp({
        res: CUSTOM_MESSAGES().NEGATIVE_BALANCE
      })
    } else {
      const paymentCheckData = seat?.paymentChecks?.filter((item, index) => index === selectedStageIndex);
      props.setSeat({ ...seat, stageData: paymentInfo, totalAmount: paymentInfo?.totalAmount, paymentCheck: paymentCheckData[0] });
      props.setPaymentCheck({ ...seat, ...paymentInfo, subTotalAmount: getSubTotalAmount(paymentInfo), paymentCheck: paymentCheckData[0] }).then(() => {
        props.resetTip();
        if ((hasAutoGratuity || paymentCheckData[0]?.hasAutoGratuity) ? isAutoGratuityPresent : tipInfo) {
          if ((hasAutoGratuity || paymentCheckData[0]?.hasAutoGratuity) ? isAutoGratuityPresent : deviceInfo?.deviceGroup?.brandTipId) {
            props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=4&type=${urlSearchParams('type')}`, { replace: true });
            props.setPaymentType(4);
          } else {
            if ((deviceInfo != null && deviceInfo?.deviceGroup != null && deviceInfo?.deviceGroup?.serverAppSettings?.powerPaymentOnly)) {
              props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=32&type=${urlSearchParams('type')}`, { replace: true })
              props.setPaymentType(32);
            } else {
              props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=31&type=${urlSearchParams('type')}`, { replace: true })
              props.setPaymentType(31);
            }
          }
        } else {
          if ((deviceInfo != null && deviceInfo?.deviceGroup != null && deviceInfo?.deviceGroup?.serverAppSettings?.powerPaymentOnly)) {
            props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=32&type=${urlSearchParams('type')}`, { replace: true })
            props.setPaymentType(32);
          } else {
            props.navigate(`${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=31&type=${urlSearchParams('type')}`, { replace: true })
            props.setPaymentType(31);
          }
        }

      });
    }
  };

  const sortedSeatItemHashTable = Object.values(seatItemHashTable).length > 0 && sortStages(Object.values(seatItemHashTable));

  useEffect(() => {
    if (sortedSeatItemHashTable) {
      let index = sortedSeatItemHashTable?.findIndex(obj => obj?.paymentComplete === false)
      setSelectedStage(sortedSeatItemHashTable[index]);
      setSelectedStageIndex(seat?.paymentChecks ? seat?.paymentChecks?.findIndex(obj => obj?.paymentComplete === false) : 0);
    }
    props.setScreenSaverStatus(false);
  }, []); // [props.seat]
  const onSwipedLeft = () => {
    if (selectedStageIndex === sortedSeatItemHashTable.length - 1) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex]);
      setSelectedStageIndex(selectedStageIndex);
    } else if (selectedStageIndex < sortedSeatItemHashTable.length - 1) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex + 1]);
      setSelectedStageIndex(selectedStageIndex + 1);
    }
  };

  const onSwipedRight = () => {
    if (selectedStageIndex === 0) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex]);
      setSelectedStageIndex(selectedStageIndex);

    } else if (selectedStageIndex <= sortedSeatItemHashTable.length - 1) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex - 1]);
      setSelectedStageIndex(selectedStageIndex - 1);
    }
  };

  const prevCheck = () => {
    if (selectedStageIndex > 0) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex - 1]);
      setSelectedStageIndex(selectedStageIndex - 1);
    }
  };

  const nextCheck = () => {
    if (selectedStageIndex < (sortedSeatItemHashTable.length - 1)) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex + 1]); setSelectedStageIndex(selectedStageIndex + 1);
    }
  };

  const multiCheckSplitPaymentConfirm = () => {
    const dataToSend = {
      storeId: deviceInfo?.storeId,
      deviceId: deviceInfo?.deviceId,
      employeeId: props.userInfo?.id,
      checkHeaderId: props.paymentCheck?.id,
      employeeCard: getObjectValue(
        () => JSON.parse(window.sessionStorage.getItem("userInfo")).employeeCard,
        null,
      ),
      cash: props?.seat.paymentCheck?.cash,
      paymentCheck: props.seat?.paymentCheck,
      paymentChecks: props.seat?.paymentChecks,
    };
    props
      .spiltCheckPayment(dataToSend)
      .then((res) => {
        setMultiCheckSplitConfirm(false);
        const splitStatus = res.paymentCheck?.splitStatus;
        const paymentCheckData = seat?.splits?.find(
          (x) => x.id === res.paymentCheck?.checkSplitId,
        );
        const paymentChecks = seat.paymentChecks?.find(
          (x) => x.checkSplitId === res.paymentCheck?.checkSplitId,
        );
        if (paymentCheckData) {
          paymentCheckData.splitStatus = splitStatus;
        }
        if (paymentChecks) {
          paymentChecks.splitStatus = splitStatus;
        }
        const splitData = seat?.splits?.map((split) =>
          split.id === splitStatus ? { ...split, splitStatus } : split,
        );
  
        const paymentChecksData = seat?.paymentChecks?.map((checks) =>
          checks?.checkSplitId === res.paymentCheck?.checkSplitId
            ? { ...checks, splitStatus }
            : checks,
        );
        props
          .setSeat({
            ...seat,
            stageData: selectedStage,
            totalAmount: selectedStage?.totalAmount,
            paymentChecks: paymentChecksData,
            paymentCheck: paymentCheckData[0],
            splits: splitData,
          })
          .then(() => {
            const seatData = JSON.parse(window.sessionStorage.getItem("seat"));
            const seatItemHashTable = {};
            seatData?.paymentChecks &&
              seatData?.paymentChecks?.length > 0 &&
              seatData?.paymentChecks?.forEach((paymentChecks, i) => {
                const splitetails = seatData?.splits?.filter(
                  (data) => data.id === paymentChecks.checkSplitId,
                )[0];
                seatItemHashTable[paymentChecks.checkSplitId] = {
                  paymentStageId: paymentChecks.checkSplitId,
                  items: paymentChecks.items,
                  taxAmount: paymentChecks.taxAmount,
                  subTotalAmount: paymentChecks.subTotalAmount,
                  stage: splitetails,
                  status: splitetails?.status,
                  totalAmount: paymentChecks.totalAmount,
                  unpaidAmount: paymentChecks.unpaidAmount,
                  paymentComplete: paymentChecks.paymentComplete,
                  paymentAmount: paymentChecks.paymentAmount,
                  splitStatus: splitetails.splitStatus,
                  seats: seatData?.seats?.reduce((a, v) => {
                    if (splitetails?.seats?.some((d) => d.seatId === v.id)) {
                      a.push({ ...v });
                    }
                    return a;
                  }, []),
                  itemAmount: paymentChecks.itemAmount,
                  offer: paymentChecks.offer,
                  offers: paymentChecks?.offers,
                  paidAmount: paymentChecks.paidAmount,
                  giftCardKey: paymentChecks.giftCard,
                  serviceChargeAmount: paymentChecks.serviceChargeAmount,
                  discountAmount: paymentChecks.discountAmount,
                  tip: paymentChecks?.tip,
                  tipCollectedAmount: paymentChecks?.tipCollectedAmount || 0,
                };
              });
            const sortedSeatItemHashTable =
              Object.values(seatItemHashTable).length > 0 &&
              sortStages(Object.values(seatItemHashTable));
            let index = sortedSeatItemHashTable?.findIndex(
              (obj) => obj.splitStatus !== 2,
            );
            const selectedStageData =
              seatData?.paymentChecks?.findIndex(
                (obj) => obj.splitStatus !== 2,
              ) === -1
                ? sortedSeatItemHashTable[sortedSeatItemHashTable?.length - 1]
                : sortedSeatItemHashTable[index];
            setSelectedStage(selectedStageData);
            const paymentIndex = seatData?.paymentChecks?.findIndex(obj => obj.splitStatus !== 2);
            setSelectedStageIndex(
              index === 0 &&
                seatData?.paymentChecks?.findIndex(
                  (obj) => obj.splitStatus !== 2,
                ) === -1
                ? sortedSeatItemHashTable?.length - 1
                : paymentIndex >= 0
                  ? paymentIndex
                  : 0,
            );
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams("ticketSplitTypeId")}&splitValue=${urlSearchParams("splitValue")}&screenType=28&type=${urlSearchParams("type")}`, { replace: true }
            );
          });
      }).catch((err) => {
        props.setErrorPopUp({
          res: err.message
        })
      })
  }

  return (
    <div className="d-flex h-100">
      {props.loading && <Loader />}
      <div className="col-12 p-0 h-100">
        {selectedStage && (
          <SwipeComponent title="Carousel" onSwipedLeft={onSwipedLeft} onSwipedRight={onSwipedRight}>
            <div
              key={selectedStage?.paymentStageId}
              className={cn(paymentLandscapeOrientation ? `col-12 px-0 pt-3 pb-2 ${props?.showCheckSeat ? 'h-93' : 'h-95'}` : 'col-12 col-md-4 px-0 h-100')}
            >
              {React.createElement(
                paymentLandscapeOrientation ? SplitCheckLandScape : SplitChecks,
                {
                  stageData: selectedStage?.stage,
                  auth: props.auth,
                  tableData: seat,
                  seatItems: selectedStage,
                  currencySymbol: LABEL().CURRENCY_SYMBOL,
                  countryCode,
                  onClickPaymentHandler,
                  allMenuItems: props.menuItems,
                  selectedStageIndex,
                  sortedSeatItemHashTable,
                  prevCheck,
                  nextCheck,
                  ShowLandscapeMode:{paymentLandscapeOrientation},
                  serverAppTheme,
                  paymentType: props.paymentType,
                  disablePayment,
                  seat,
                  setPaymentCheck: props.setPaymentCheck,
                  setSeat: props.setSeat,
                  getSubTotalAmount,
                  multiCheckSplitPaymentConfirm,
                  setMultiCheckSplitConfirm,
                  multiCheckSplitConfirm,
                  showCheckSeat: props?.showCheckSeat
                }
              )}
            </div>

          </SwipeComponent>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({
  oauth,
  orders,
  stage,
  payment
}) => ({
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  auth: oauth.authInfo,
  seat: orders.seats,
  position: orders.position,
  loading: stage.loading || orders.loading,
  isEmployeeCheck: oauth.isEmployeeCheck,
  menuItems: orders.menuItems,
  paymentCheck: orders.paymentCheck,
  paymentLandscapeOrientation: payment.paymentLandscapeOrientation
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setNotification,
  updateWithPaymentStages,
  removeWithPaymentStages,
  setPaymentCheck,
  openEmployeeCheck,
  setSeat,
  setScreenSaverStatus,
  setErrorPopUp,
  spiltCheckPayment
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StagePayment);
